import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import PromoCodesTable from "../components/promocodes/promocodeTable";

import { SearchAndFilterToolbar, StatusBar } from "../components/common";
import PageBodyWrapper from "../components/PageBodyWrapper";
import useApi from "../api";
import { parseSearchParams } from "../components/common/filterableForm";

import { Paginator } from "../components/common";

import PromocodeFilter from "../components/promocodes/promoFilter";
import PromoCodeForm from "../components/promocodes/PromoCodeForm";
import { handleRetriveError } from "../utils";

interface OrderResponse {
  results: any[]; 
}

function PromoCodes() {
  const [openOrderFilterModal, setOpenOrderFilterModal] = useState(false);
  const [promocodes, setPromocodes] = useState<OrderResponse | null>(null);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [filterData, setFilterData] =  useState<any>({});
  const [edit, setEdit] = useState<any>()

  const [searchParams, setSearchParams] = useSearchParams();
  const api = useApi();
  
  const fetchPromoCodes = () => {
    const queryObject = parseSearchParams(searchParams);
    api.getPromocodes(queryObject).then((response: any) => {
        setPromocodes(response);
      }, handleRetriveError)};

  useEffect(() => {
    fetchPromoCodes();
  }, [searchParams]);



  return (
    <PageBodyWrapper>
      <StatusBar
        onButtonClick={()=>setOpenModal(!openModal)}
        statusList={[]} 
        buttonLabel="Add Promocode"
        fieldName="status"
      />
      <SearchAndFilterToolbar
        onFilterOpen={() => setOpenOrderFilterModal(!openOrderFilterModal)}
        onRefresh={fetchPromoCodes}
        startDateKey={"created_at_after"}
        endDateKey={"created_at_before"}
      />
      
      {/* Render OrderFilter when openOrderFilter is true */}
      {openOrderFilterModal && <PromocodeFilter onClose={() => setOpenOrderFilterModal(false)} />}
      

      <div className="px-1">
        <PromoCodesTable promocodes={promocodes?.results || []} fetchPromoCodes={fetchPromoCodes} setEdit={setEdit} setOpenModal={setOpenModal}/>
      </div>

      <Paginator data={promocodes} />

      {openModal && <PromoCodeForm edit={edit} isOpen={openModal} onClose={()=>{
        setOpenModal(!openModal)
        setEdit(null)
      }} fetchPromoCodes={fetchPromoCodes}/>}

    </PageBodyWrapper>
  );
}

export default PromoCodes;
